import { render, staticRenderFns } from "./intelligent-test-pape.vue?vue&type=template&id=2a22e524"
import script from "./intelligent-test-pape.vue?vue&type=script&lang=js"
export * from "./intelligent-test-pape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports